import React, { Component } from 'react'

class OverallEngagementChart extends Component {
  getValue = (value, fallback) => {
    return typeof value === 'number' && value >= 0 ? value : fallback
  }

  getChartData = () => {
    const items = [
      {
        label: 'Appointments',
        completed: this.getValue(this.props.appointmentsCompleted, 1),
        total: this.getValue(this.props.appointmentsTotal, 2),
      },
      {
        label: 'Assessments',
        completed: this.getValue(this.props.assessmentsCompleted, 2),
        total: this.getValue(this.props.assessmentsTotal, 2),
      },
      {
        label: 'Patient Navigator Meetings',
        completed: this.getValue(this.props.pnCompleted, 0),
        total: this.getValue(this.props.pnTotal, 0),
      },
      {
        label: 'To-do List items completed',
        completed: this.getValue(this.props.pnCompleted, 0),
        total: this.getValue(this.props.pnTotal, 0),
      },
    ].map(item => {
      const completed = Math.min(item.completed, item.total)
      const percentage = item.total > 0
        ? Math.round((completed / item.total) * 100)
        : 0

      return {
        ...item,
        completed,
        percentage,
      }
    })

    const completed = items.reduce((sum, item) => sum + item.completed, 0)
    const total = items.reduce((sum, item) => sum + item.total, 0)
    const percentage = total > 0
      ? Math.round((completed / total) * 100)
      : 0

    return {
      items,
      completed,
      total,
      percentage,
    }
  }

  render() {
    const engagement = this.getChartData()

    return (
      <div className="small-12 columns" style={styles.container}>
        <div className="title6">
          Your Engagement: Past 6 Weeks
        </div>

        <br />

        <div
          role="img"
          aria-label={`Overall engagement ${engagement.percentage}% completed`}
          style={styles.chart}
        >
          {engagement.items.map(item => (
            <div key={item.label} style={styles.row}>
              <div style={styles.label1}>{item.label}</div>

              <div style={styles.barBackground}
                aria-label={`${item.label}: ${item.completed} of ${item.total} completed`} >
                <div style={{ ...styles.barCompleted, width: `${item.percentage}%`, }} />
              </div>

              <div style={styles.value}>
                <strong>{item.completed} of {item.total}</strong>
                <span style={styles.percentage}> {item.percentage}%</span>
              </div>
            </div>
          ))}
        </div>

        <div style={styles.legend}>
          <span style={styles.legendItem}>
            <span style={{ ...styles.legendColor, backgroundColor: '#43a047' }} />
            Completed
          </span>
          <span style={styles.legendItem}>
            <span style={{ ...styles.legendColor, backgroundColor: '#e0e0e0' }} />
            Not completed
          </span>
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    color: '#263238',
  },
  summary: {
    fontSize: 15,
    margin: '8px 0 18px',
  },
  chart: {
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
  },
  row: {
    display: 'grid',
    gridTemplateColumns: 'minmax(150px, 1.2fr) minmax(200px, 3fr) 120px',
    alignItems: 'center',
    columnGap: 14,
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
  },
  label1: {
    fontSize: 13,
    fontWeight: 600,
  },
  barBackground: {
    height: 20,
    overflow: 'hidden',
    backgroundColor: '#e0e0e0',
    borderRadius: 4,
  },
  barCompleted: {
    height: '100%',
    minWidth: 0,
    backgroundColor: '#43a047',
    borderRadius: 4,
  },
  value: {
    fontSize: 14,
    whiteSpace: 'nowrap',
  },
  percentage: {
    color: '#546e7a',
    marginLeft: 4,
  },
  legend: {
    display: 'flex',
    gap: 18,
    marginTop: 16,
    fontSize: 12,
    color: '#546e7a',
  },
  legendItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
  },
  legendColor: {
    display: 'inline-block',
    width: 12,
    height: 12,
    borderRadius: 2,
  },
}

export default OverallEngagementChart
